module.exports = __webpack_public_path__ + "static/media/5-ways-to-make-cash.d5bdd19f.jpg";